export function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
}

export function getComparator(order, orderBy) {
    return order === "asc"
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

export function handleSort(order, orderBy, property, setOrder, setOrderBy) {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
}

export function handleChangePage(event, newPage, setPage) {
    setPage(newPage);
}

export function handleChangeRowsPerPage(event, setRowsPerPage, setPage) {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
}